import { episodeOfCareAction } from 'src/redux/actions/constant';

const {
  CLOSE_EPISODE_OF_CARE_FAILURE,
  CLOSE_EPISODE_OF_CARE_SUCCESS,
  RESET_CLOSE_EPISODE_OF_CARE,
  CLOSE_EPISODE_OF_CARE_LOADING,
} = episodeOfCareAction;

const intitialstate: object = {
  isClosed: false,
  response: null,
  loading: false,
};

export const closeEpisodeOfCareReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case CLOSE_EPISODE_OF_CARE_SUCCESS: {
      return {
        ...state,
        isClosed: true,
        response: action.payload,
        loading: false,
      };
    }

    case CLOSE_EPISODE_OF_CARE_FAILURE:
      return {
        ...state,
        isClosed: false,
        response: action.payload,
        loading: false,
      };

    case CLOSE_EPISODE_OF_CARE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case RESET_CLOSE_EPISODE_OF_CARE:
      return intitialstate;
    default:
      return state;
  }
};
